// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-table-network-analyst {
  font-size: 13px;
  border-radius: 0.5rem;
  border: 1px solid #E4E7F0;
  background-color: #FFFFFF;
  padding: 1rem;
}
.container-table-network-analyst table {
  width: 100%;
}
.container-table-network-analyst th {
  font-weight: 500;
}
.container-table-network-analyst th.header-group {
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
}
.container-table-network-analyst tr:last-of-type {
  border: none !important;
}
.container-table-network-analyst a {
  color: #11BC97 !important;
  text-decoration: underline !important;
}
.container-table-network-analyst a:hover {
  color: #0ead8a !important;
  text-decoration: underline !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/table.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;AADF;AAGE;EACE,WAAA;AADJ;AAIE;EACE,gBAAA;AAFJ;AAII;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;AAFN;AAME;EACE,uBAAA;AAJJ;AAOE;EACE,yBAAA;EACA,qCAAA;AALJ;AAOI;EACE,yBAAA;EACA,qCAAA;AALN","sourcesContent":["@import './colors';\r\n\r\n.container-table-network-analyst {\r\n  font-size: 13px;\r\n  border-radius: 0.5rem;\r\n  border: 1px solid #E4E7F0;\r\n  background-color: #FFFFFF;\r\n  padding: 1rem;\r\n\r\n  table {\r\n    width: 100%;\r\n  }\r\n\r\n  th {\r\n    font-weight: 500;\r\n\r\n    &.header-group {\r\n      font-weight: bold;\r\n      text-transform: uppercase;\r\n      text-align: center;\r\n    }\r\n  }\r\n\r\n  tr:last-of-type {\r\n    border: none !important;\r\n  }\r\n\r\n  a {\r\n    color: $color-green !important;\r\n    text-decoration: underline !important;\r\n\r\n    &:hover {\r\n      color: $color-secGreen !important;\r\n      text-decoration: underline !important;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
